import React, { useState } from 'react'
import {
  message,
  Form,
  AutoComplete,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Button,
  Table,
  Select
} from 'antd'
import ds from '../Services/DataServices'
import { useSelector, useDispatch } from 'react-redux'
import {
  loadShowContactUs,
  loadContactUsLoader
} from '../appRedux/actions/CommonData'
import { isEmailValid, isEmptyObject } from '../appRedux/actions'
import { BEHAVIOUR_TYPE } from '../Services/DataServices'
import { checkIsWeb } from '../appRedux/actions/MobAppFn'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const { TextArea } = Input
const Options = {
  LocationOptions: [
    { Id: 1, label: '1 location' },
    { Id: 2, label: '2-9 locations' },
    { id: 3, label: '10+ locations' }
  ]
}

const ContactUsDialog = props => {
  const { countriesObject, businessObjects } = props
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const showContactUs = useSelector(
    ({ commonConfigs }) => commonConfigs.showContactUs
  )

  const showContactLoader = useSelector(
    ({ commonConfigs }) => commonConfigs.showContactLoader
  )

  const [getTableData, setTableData] = React.useState([])

  function onFinish (values) {
    if (!isEmptyObject(values)) {
      dispatch(loadContactUsLoader(true))
      postContact(values)
    } else message.warn('Kindly provide proper information')
  }

  async function postContact (values) {
    await ds
      .postContactService(
        {
          Name: values.name ? values.name : '',
          Email: values.email ? values.email : '',
          PhoneNo: values.phone ? values.phone : '',
          CountryID: values.countryID ? values.countryID : '',
          BusinessID: values.businessType ? values.businessType : '',
          NumberOfLocation: values.locations ? values.locations : ''
        },
        BEHAVIOUR_TYPE.POST
      )
      .then(response => {
        dispatch(loadContactUsLoader(false))
        if (response && response == 'Result') {
          form.resetFields()
          message.success('Successfully Sent')
        } else message.error('Check conection & Try Again')
      })
      .catch(e => {
        dispatch(loadContactUsLoader(false))
        message.error('Something went wrong')
      })
  }

  return (
    <Modal
      className='ContactUs-Modal'
      centered
      visible={showContactUs}
      footer={
        <>
          <Button form='brands' className='' type='primary' htmlType='submit'>
            Send
          </Button>
        </>
      }
      title='Contact Us'
      width={getTableData.length > 0 ? 800 : 600}
      onCancel={() => {
        if (!showContactLoader) {
          dispatch(loadShowContactUs(false))
        }
      }}
      cancelButtonProps={{
        className: 'dk-btn-cancel'
      }}
    >
      <Spin tip={'Loading'} spinning={showContactLoader} size='large'>
        <div>
          <Form
            {...formItemLayout}
            form={form}
            name='brands'
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            initialValues={{
              prefix: '86'
            }}
            scrollToFirstError
          >
            <Row>
              <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right'
                  name='name'
                  label={
                    <span>
                      <strong>Business Name</strong>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Please enter Business name',
                      whitespace: true
                    }
                  ]}
                >
                  <Input placeholder='Business Name' />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right'
                  name='email'
                  label={
                    <span>
                      <strong>Email Address</strong>
                    </span>
                  }
                  rules={[
                    // {
                    //   type: 'email',
                    //   message: 'The input is not valid Email Address!'
                    // },
                    {
                      required: true,
                      message: 'Please input your Email Address!'
                    },
                    {
                      validator: isEmailValid
                    }
                  ]}
                >
                  <Input placeholder='Email Address' />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right'
                  name='phone'
                  label={
                    <span>
                      <strong>Phone No</strong>
                    </span>
                  }
                >
                  <Input placeholder='Your Phone No' />
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right'
                  name='countryID'
                  label={
                    <span>
                      <strong>Country</strong>
                    </span>
                  }
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Select your country'
                    }
                  ]}
                >
                  <Select
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                    placeholder='Select Country'
                  >
                    {countriesObject &&
                      countriesObject.map((e, key) => {
                        return (
                          <option key={key} value={e.id}>
                            {e.label}
                          </option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                <Form.Item
                  className='ant-form-item-label-custom'
                  name='businessType'
                  label={
                    <span>
                      <strong>Type of Business</strong>
                    </span>
                  }
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Please choose your retail category.'
                    }
                  ]}
                >
                  <Select
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                    placeholder='Choose a business category'
                  >
                    {businessObjects &&
                      businessObjects.map((e, key) => {
                        return (
                          <option key={key} value={e.id}>
                            {e.label}
                          </option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                <Form.Item
                  className='ant-form-item-label-custom'
                  name='locations'
                  label={
                    <span>
                      <strong>Number of Locations</strong>
                    </span>
                  }
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Please choose the number of locations you have.'
                    }
                  ]}
                >
                  <Select
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                    placeholder='Choose how many locations you have'
                  >
                    {Options.LocationOptions &&
                      Options.LocationOptions.map((e, key) => {
                        return (
                          <option key={key} value={e.label}>
                            {e.label}
                          </option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Spin>
    </Modal>
  )
}

export default ContactUsDialog
